module.exports = __webpack_public_path__ + "img/LongGang.1ac23a2c.png";